import BaseAPI from "../api";

const path: string = 'departments'

export interface departmentTypes {
    keyword?: string;
    limit?: number;
    page?: number;
}
export interface departmentEditType {
    departmentName: string;
    departmentStatus: string;
    departmentAddress: string;
    departmentTel: string;
    departmentFax: string;
    departmentEmail: string;
    idDepartmentRef: any
}
export interface createDepartment {
    departmentName: string;
    departmentAddress: string;
    departmentTel: string;
    departmentFax: string;
    departmentEmail: string;
    departmentStatus: string;
    idDepartmentRef: number | null
}
export interface updateDepartment {
    departmentName: string;
    departmentAddress: string;
    departmentTel: string;
    departmentFax: string;
    departmentEmail: string;
    departmentStatus: string;
    idDepartmentRef: number | null
}

export class DepartMentApi extends BaseAPI {
    public static createDepartments(props: departmentEditType): Promise<any> {
        return this.api.post(`${path}`, props).then(res => res);
    }
    public static getDepartments(props: departmentTypes): Promise<any> {
        return this.api.get(`${path}`, { params: { ...props } }).then(res => res);
    }
    public static editDepartments(id: number, props: departmentEditType): Promise<any> {
        return this.api.patch(`${path}/${id}`, props).then(res => res);
    }
    public static getDetailDepartment(id: number): Promise<any> {
        return this.api.get(`${path}/${id}`).then(res => res);
    }
}